import LinkCrossSell from '../LinkCrossSell';
import { ReauthError } from '../ReauthError';
import React from 'react';
import LinkPlaidSuccess from './LinkPlaidSuccess';

export const PlaidSuccessStates = ({
	showCrossSell,
	accountName,
	accountType,
	maskedNumber,
	isLinked,
	successPath,
	reauthorizationError,
	postReauthError,
}) => {
	return reauthorizationError ? (
		<ReauthError error={reauthorizationError} />
	) : postReauthError ? (
		<ReauthError error={postReauthError} />
	) : showCrossSell ? (
		<LinkCrossSell
			accountName={accountName}
			maskedNumber={maskedNumber}
			isLinked={isLinked}
			successPath={successPath}
		/>
	) : (
		<LinkPlaidSuccess
			accountName={accountName}
			accountType={accountType}
			maskedNumber={maskedNumber}
			successPath={successPath}
		/>
	);
};
